import type { QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"
import { NuqsAdapter } from "nuqs/adapters/tanstack-router"

import { RouteLoading } from "@/components/route-loading"
import { getProfile } from "@/http/auth/get-profile"
import { ensureSession } from "@/http/auth/session"
import { type TAuthState, useAuth } from "@/store/auth"
import type { TBreadcrumbState } from "@/store/breadcrumbs"
import type { TOrganizationState } from "@/store/organization"

type TRouterContext = {
  authentication: TAuthState
  breadcrumbs: TBreadcrumbState
  organization: TOrganizationState
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<TRouterContext>()({
  loader: async () => {
    const hasSession = await ensureSession()
    if (!hasSession) return null

    const profile = await getProfile()
    if (profile.error || !profile.data) return null

    // Hydrate auth store BEFORE any component renders to prevent FOUC
    const authState = useAuth.getState()
    if (!authState.user) {
      authState.setProfile(profile.data)
    }

    return profile.data
  },
  component: RootRouteComponent,
  pendingComponent: RouteLoading,
})

function RootRouteComponent() {
  return (
    <NuqsAdapter>
      <Outlet />
    </NuqsAdapter>
  )
}
